import { render } from "./calendar-index.vue?vue&type=template&id=ec0186f8"
import script from "./calendar-index.vue?vue&type=script&lang=js"
export * from "./calendar-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__